import { dsColorNew } from '@palette'

// The one tone map of every DS Repricing status chip (pushes, sends, events, resolutions, rules, the
// calendar), one meaning each: green done, blue waiting or derived, amber limited, indigo test or
// quarantine, red failed, grey nothing happened. A tone, not a colour per state: the label says which.
export const TONES = {
	ok:      { bg: dsColorNew.successBg,    fg: dsColorNew.successText },
	info:    { bg: dsColorNew.pillActiveBg, fg: dsColorNew.appBlue },
	warn:    { bg: dsColorNew.noteAmberBg,  fg: dsColorNew.noteAmber },
	accent:  { bg: dsColorNew.noteInfoBg,   fg: dsColorNew.noteInfo },
	err:     { bg: dsColorNew.dangerBg,     fg: dsColorNew.dangerRed },
	neutral: { bg: dsColorNew.pillTrackBg,  fg: dsColorNew.textDark },
}

export const toneOf = (tone) => TONES[tone] || TONES.neutral

// The pill of AppStatusPill (`@components/DataBlocks/DetailBlocks`) for a plain span
export const tonePillSx = (tone) => {
	const t = toneOf(tone)
	return {
		display: 'inline-flex', alignItems: 'center', gap: 0.75, px: 1.1, py: 0.4, borderRadius: '999px',
		backgroundColor: t.bg, color: t.fg, fontSize: 12, fontWeight: 500, lineHeight: 1.4, whiteSpace: 'nowrap',
	}
}

// The same pill on a MUI Chip, for the chips that click or carry an icon
export const toneChipSx = (tone, { clickable = false } = {}) => {
	const t = toneOf(tone)
	return {
		height: 24, maxWidth: '100%', borderRadius: '999px',
		bgcolor: t.bg, color: t.fg, fontSize: 12, fontWeight: 500,
		'& .MuiChip-label': { px: 1.1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' },
		'& .MuiChip-icon': { fontSize: 13, color: `${t.fg} !important`, ml: 1, mr: -0.5 },
		...(clickable && { cursor: 'pointer', '&:hover': { bgcolor: t.bg, filter: 'brightness(0.94)' } }),
	}
}

export default TONES
